import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { getPrelistProductAndServiceDetailsApi, getPrelistProductPaginatedApi } from './prelistProductServiceApi';

// ----------------------------------------------------------------------

const initialState = {
  prelistProductList: [],
  isPrelistProductLoading: false,
  prelistProductPageNo: 0,
  prelistProductPageSize: 100,
  selectedPrelistProductAndService: {}
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    increasePrelistProductPageNo: (state, action) => {
      state.prelistProductPageNo = action.payload;
    }
  },
  extraReducers: {
    [getPrelistProductPaginatedApi.fulfilled]: (state, action) => {
      const { result = [], isAppend = false, hasMoreStoreData } = action.payload;
      state.hasMoreStoreData = hasMoreStoreData;
      state.isPrelistProductLoading = false;
      if (isAppend) {
        state.prelistProductList = _.concat(state.prelistProductList, result);
      } else {
        state.prelistProductList = result;
      }
    },
    [getPrelistProductAndServiceDetailsApi.fulfilled]: (state, action) => {
      state.selectedPrelistProductAndService = action.payload;
    }
  }
});
export const prelistProductAndServiceAction = slice.actions;

export default slice.reducer;
